export const BASE_URL =
    (process.env.REACT_APP_API_ROOT_DATUM || process.env.REACT_APP_API_ROOT_DEFAULT) +
    '/datum/';

export const urls = {
    constants: BASE_URL + 'constants/',
    constants_types: BASE_URL + 'constants/types/',
    constant_details: BASE_URL + 'constants/:id/',
};
